import { ResultGroup } from '@src/suite/common/data-models/search-results/result-group';
import { TreeLikeFlatNode, TreeLikeNode } from '@src/suite/common/data-models/search-results/search-results';

export const getNodeLevel = ({ level }: TreeLikeFlatNode<StorytellingRundownRecord>) => {
    return level;
};

// Function that determines whether a flat node is expandable or not
export const getIsNodeExpandable = ({ hasChildren }: TreeLikeFlatNode<StorytellingRundownRecord>) => {
    return hasChildren;
};

// Function that returns a nested node's list of children
export const getNodeChildren = ({ children }: TreeLikeNode<StorytellingRundownRecord>) => {
    return children;
};

// Function that maps a nested node to a flat node
export const nodeTransformer = (node: TreeLikeNode<StorytellingRundownRecord>, level: number): TreeLikeFlatNode<StorytellingRundownRecord> => {
    return {
        id: node.id,
        label: node.label,
        uniqueId: node.uniqueId,
        index: node.index,
        itemsCount: node.itemsCount,
        level,
        hasChildren: node?.children?.length > 0,
        object: node.object,
        nodeLastInGroup: node.nodeLastInGroup,
        nodeFirstInGroup: node.nodeFirstInGroup,
        linkedRecordType: node?.linkedRecordType,
        isMetadata: node?.isMetadata,
        isNewItems: node?.isNewItems,
        cost: node?.cost,
    };
};

export const getRundownsTreeLikeData = (rundowns: ResultGroup<StorytellingRundownRecord>): TreeLikeNode<StorytellingRundownRecord>[] => {
    return rundowns.keys.map(key => ({
        id: key.value,
        uniqueId: key.value,
        label: key.display,
        itemsCount: rundowns.entries[key.value].length,
        children: rundowns.entries[key.value].map((entry, index) => ({
            id: entry?.Guid,
            uniqueId: `${key.value}-${entry?.Guid}`,
            children: [],
            object: entry,
            nodeFirstInGroup: index === 0,
            nodeLastInGroup: index === rundowns.entries[key.value].length - 1,
        })),
    }));
};

export const getRundownsSearchResultsTreeLikeData = (records: ResultGroup<StorytellingRecord>): TreeLikeNode<StorytellingRecord>[] => {
    return records.keys.map(key => ({
        id: 'rundowns',
        uniqueId: 'rundowns',
        label: 'Rundowns',
        itemsCount: records.entries[key.value].length,
        children: records.entries[key.value].map((entry, index) => ({
            id: entry?.Guid,
            uniqueId: `${'rundowns'}-${entry?.Guid}`,
            children: [],
            object: entry,
            nodeFirstInGroup: index === 0,
            nodeLastInGroup: index === records.entries[key.value].length - 1,
        })),
    }));
};
